import * as fp from "lodash/fp";

const handlers = {};

export const get = (key:string, fallbackValue:any = null) => {
    try {
        return JSON.parse( sessionStorage.getItem( key ) ) || fallbackValue;
    } catch (e) { }

    return fallbackValue;
};

export const set = (key:string, value:any) => {
    try {
        sessionStorage.setItem( key, JSON.stringify(value) );
        fp.getOr([], key, handlers).map( handler => handler({key, value}) )
    } catch (e) {}
};

/**
 *
 * @param key - the key in storage that will be listened
 * @param handler - the handler that will be called whenever value under key name will be updated
 *
 * i.e. onStorageChange('compareIds', () => this.setState({ carsToCompare: storage.get('compareIds', []) }))
 *
 * @return unsubscribe function
 */
export const onStorageChange = (key, handler) => {
    handlers[key] = [...fp.getOr([], key, handlers), handler];

    return () => { handler[key] = fp.without(handler, fp.getOr([], key, handlers)) };
};



// WEBPACK FOOTER //
// ./resources/modules/utilities/storage.ts